import { logger } from '@services/logger/logger.service';

const loggingMiddleware = () => (next: (arg0: any) => any) => (action: { type: string }) => {
  logger.info('STATE', action.type);

  return next(action);
};

export default loggingMiddleware;
